import { KnownBusinessEntitySaleItem } from "@/models/known-business-entity-sale-item.model.ts"
import type { IKnownBusinessEntitySaleItem } from "@/interfaces/api/known-business-entity-sale-item.interface.ts"
import { KnownBusinessEntitySaleItemRepository } from "@/repositories/known-business-entity-sale-item-repository.ts"
import { useKnownBusinessEntitiesSaleItemsStore } from "@/store/known-business-entities-sale-items.store.ts"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { storeToRefs } from "pinia"
import { AbstractKnownBusinessEntityAdministrativeItemController } from "@/controllers/model-controllers/abstract/abstract-known-business-entity-administrative-item-controller.ts"

export class KnownBusinessEntitySaleItemController extends AbstractKnownBusinessEntityAdministrativeItemController<
  KnownBusinessEntitySaleItem,
  IKnownBusinessEntitySaleItem,
  KnownBusinessEntitySaleItemRepository
> {
  constructor() {
    const knownBusinessEntitiesSaleItemsStore = useKnownBusinessEntitiesSaleItemsStore()
    const { knownBusinessEntitiesSaleItems } = storeToRefs(knownBusinessEntitiesSaleItemsStore)
    const storeFunctionsConfig = {
      collection: knownBusinessEntitiesSaleItems
    }

    super(
      KnownBusinessEntitySaleItem,
      storeFunctionsConfig,
      new KnownBusinessEntitySaleItemRepository()
    )
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      KnownBusinessEntitySaleItem,
      knownBusinessEntitiesSaleItems
    )
  }
}
